import { memo, useCallback } from 'react'

import { ContactWorkflowStatus, IContact } from 'clickNgo/entities/contact'
import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'

import { useReadOnlyMenuItem } from '../../hooks/useReadOnlyMenuItem'
import { contactEditorTranslation } from '../../translation'

import styles from './ContactWorkflowStatusPanel.module.scss'

type TProps = {
  contact: IContact
  onRemoveRequest: () => Promise<void>
}

export const ContactWorkflowStatusPanel = memo<TProps>(({ contact, onRemoveRequest }) => {
  /** ------------------------- Variables -------------------------- */
  const { isReadOnly } = useReadOnlyMenuItem()

  const isResolved =
    contact.workflowStatus &&
    [ContactWorkflowStatus.Done, ContactWorkflowStatus.Rejected].includes(contact.workflowStatus)

  /** ------------------------- Handlers -------------------------- */

  const renderRemovedButtonTooltip = useCallback(
    () => <Translation text={contactEditorTranslation.workflowStatus.button.remove} span />,
    []
  )

  if (contact.workflowStatus) {
    return (
      <div className={styles.container}>
        <div className={styles.status}>
          <div className={styles.statusLabel}>
            <Translation text={contactEditorTranslation.workflowStatus.label} span />
          </div>
          <div className={styles.statusValue}>{contact.workflowStatus}</div>
        </div>
        <div className={styles.actions}>
          <RenderWhen condition={!isResolved && !isReadOnly}>
            <Tooltip tipContent={renderRemovedButtonTooltip}>
              <Button
                onClick={onRemoveRequest}
                color="danger"
                variant="text"
                icon="kbase kbase-delete-alt"
              >
                <Translation text={contactEditorTranslation.workflowStatus.button.remove} span />
              </Button>
            </Tooltip>
          </RenderWhen>
        </div>
      </div>
    )
  }

  return null
})

ContactWorkflowStatusPanel.displayName = 'ContactWorkflowStatusPanel'
